import template from './navigation.html';
import { rest } from 'core/api';
import configFile from 'config.json';

export let NavigationComponent = {
  templateUrl: template,
  selector: 'navigation',
  bindings: {
    translations: '=',
    search: '='
  },
  controller: NavigationCtrl,
  controllerAs: 'vm'
};


NavigationCtrl.$inject = ['$ngRedux', 'AuthorizationService'];

function NavigationCtrl($ngRedux, AuthorizationService) {
  this.mapStateToThis = mapStateToThis.bind(this);
  this.versionFrontend = configFile.versionFrontend;
  this.setNodes = setNodes.bind(this);
  const unsubscribe = $ngRedux.connect(this.mapStateToThis, rest.events.currentUser)(this);
  this.$onDestroy = () => {
    unsubscribe();
  };
  this.isEmpty = (node) => {
    const allowedNodes = node.nodes.reduce((allowedNodes, currNode) => {
      const allowedChildNodes = (currNode.permissions || []).reduce((isAllowed, permission) => {
        return isAllowed && AuthorizationService.hasPermission(permission);
      }, true);
      return allowedChildNodes + allowedNodes;
    }, 0);
    return allowedNodes === 0;
  }
}

function mapStateToThis(state) {
  if (state.currentUser) {
    this.setNodes();
  }
  return { currentUser: state.currentUser };
}

function setNodes() {
  // elementos del sidebar
  this.nodes = [
    {
      header: this.translations['Productos'],
      nodes: [
        {
          text: this.translations['Administrar productos'],
          sref: 'home.productos.list',
          classes: ['glyph-icon', 'icon-cube'],
          permissions: ['index_productos']
        }, {
          text: this.translations['Categorías de productos'],
          sref: 'home.categorias-productos.list',
          classes: ['glyph-icon', 'icon-tags'],
          permissions: ['index_categorias_productos']
        }, {
          text: this.translations['Marcas'],
          sref: 'home.marcas.list',
          classes: ['glyph-icon', 'icon-book'],
          permissions: ['index_marcas']
        }, {
          text: this.translations['Unidades de medida'],
          sref: 'home.unidades-medidas.list',
          classes: ['glyph-icon', 'icon-signal'],
          permissions: ['index_unidades_medidas']
        }, {
          text: this.translations['Familias de productos'],
          sref: 'home.familias-productos.list',
          classes: ['glyph-icon', 'icon-cubes'],
          permissions: ['index_familias_productos']
        }, {
          text: this.translations['Proveedores'],
          sref: 'home.proveedores.list',
          classes: ['glyph-icon', 'icon-truck'],
          permissions: ['index_proveedores']
        }, {
          text: this.translations['Adicionales'],
          sref: 'home.adicionales.list',
          classes: ['glyph-icon', 'icon-plus-square-o'],
          permissions: ['index_adicionales']
        }, {
          text: this.translations['Especialidades'],
          sref: 'home.especialidades.list',
          classes: ['glyph-icon', 'icon-suitcase'],
          permissions: ['index_especialidades']
        }
      ]
    }, {
      header: this.translations['Ventas'],
      nodes: [
        {
          text: this.translations['Tipos de comprobantes'],
          sref: 'home.tipos-comprobantes.list',
          classes: ['glyph-icon', 'icon-file-text-o'],
          permissions: ['index_tipos_comprobantes']
        },
        {
          text: this.translations['Sucursales'],
          sref: 'home.sucursales.list',
          classes: ['glyph-icon', 'fa', 'fa-university'],
          permissions: ['index_sucursales']
        },
        {
          text: this.translations['Timbrados'],
          sref: 'home.timbrados.list',
          classes: ['glyph-icon', 'fa', 'fa-barcode'],
          permissions: ['index_timbrados']
        },
        {
          text: this.translations['Puntos de Venta'],
          sref: 'home.puntos-emision.list',
          classes: ['glyph-icon', 'icon-laptop'],
          permissions: ['index_sucursales']
        },
        {
          text: this.translations['Cajas'],
          sref: 'home.cajas.list',
          classes: ['glyph-icon', 'icon-print'],
          permissions: ['index_cajas']
        },
        {
          text: this.translations['Cotizaciones'],
          sref: 'home.cotizaciones.list',
          classes: ['glyph-icon', 'icon-money'],
          permissions: ['index_cotizaciones']
        },
        {
          text: this.translations['Precios'],
          sref: 'home.precios.list',
          classes: ['glyph-icon', 'icon-tags'],
          permissions: ['index_precios']
        },
        {
          text: this.translations['Paquetes'],
          sref: 'home.paquetes.list',
          classes: ['glyph-icon', 'icon-cube'],
          permissions: ['index_paquetes']
        },
        {
          text: this.translations['Paquetes de Cliente'],
          sref: 'home.clientes.paquetes-cliente-list.list',
          classes: ['glyph-icon', 'icon-cube'],
          permissions: ['index_paquetes']
        },
        {
          text: this.translations['Tipos de atributo de cliente'],
          sref: 'home.tipos-atributo-cliente.list',
          classes: ['glyph-icon','icon-typicons-tags'],
          permissions: ['index_tipo_atributo_cliente']
        },
        {
          text: this.translations['Atributos de cliente'],
          sref: 'home.atributos-cliente.list',
          classes: ['glyph-icon','icon-typicons-tag'],
          permissions: ['index_atributo_cliente']
        },
        {
          text: this.translations['Giftcards'],
          sref: 'home.giftcards.list',
          classes: ['glyph-icon', 'icon-gift'],
          permissions: ['index_giftcards']
        },
        {
          text: this.translations['Clientes'],
          sref: 'home.clientes.list',
          classes: ['glyph-icon', 'icon-users'],
          permissions: ['index_clientes']
        },
        {
          text: this.translations['RUC'],
          sref: 'home.ruc.list',
          classes: ['glyph-icon', 'icon-users'],
          permissions: ['index_ruc']
        },
        {
          text: this.translations['Procesos Batch'],
          sref: 'home.procesos-batch.list',
          classes: ['glyph-icon', 'icon-archive']
        },
        {
          text: this.translations['Citas'],
          sref: 'home.citas.list',
          classes: ['glyph-icon', 'icon-th'],
          permissions: ['index_citas']
        },
        {
          text: this.translations['Turnos'],
          sref: 'home.turnos.list',
          classes: ['glyph-icon', 'icon-th'],
          permissions: ['index_turnos']
        },
        {
          text: this.translations['Citas Detalles'],
          sref: 'home.citas.detalles',
          classes: ['glyph-icon', 'icon-th'],
          permissions: ['index_citas']
        },
        {
          text: this.translations['Ordenes de Trabajo'],
          sref: 'home.ordenes.list',
          classes: ['glyph-icon', 'icon-th-large'],
          permissions: ['index_orden_trabajo']
        },
        {
          text: this.translations['Ordenes Detalles'],
          sref: 'home.ordenes.detalles',
          classes: ['glyph-icon', 'icon-th-large'],
          permissions: ['index_orden_trabajo']
        },
        {
          text: this.translations['Tablero de Trabajo'],
          sref: 'tablero-trabajo',
          classes: ['glyph-icon', 'icon-th-list']
        },
        {
          text: this.translations['Tablero de Especialistas'],
          sref: 'tablero-especialistas',
          classes: ['glyph-icon', 'icon-list-ul']
        },
        {
          text: this.translations['Tablero de Comisiones'],
          sref: 'tablero-comisiones',
          classes: ['glyph-icon', 'icon-align-right'],
          permissions: ['tablero_comisiones']
        },
        {
          text: this.translations['Facturas'],
          sref: 'home.facturas.list',
          classes: ['glyph-icon', 'icon-file'],
          permissions: ['index_facturas']
        },
        {
          text: this.translations['Cuotas'],
          sref: 'home.cuotas.list',
          classes: ['glyph-icon', 'icon-file'],
          permissions: ['index_cuota_cabeceras']
        },
        {
          text: this.translations['Notas Credito'],
          sref: 'home.notas-credito.list',
          classes: ['glyph-icon', 'icon-file'],
          permissions: ['index_notas_credito']
        },
        {
          text: this.translations['Formas de Pago'],
          sref: 'home.formas-pago.list',
          classes: ['glyph-icon', 'icon-ruble'],
          permissions: ['index_formas_pago']
        },
        {
          text: this.translations['Procesadoras de Tarjetas'],
          sref: 'home.procesadoras-tarjetas.list',
          classes: ['glyph-icon', 'icon-credit-card'],
          permissions: ['index_tarjetas']
        },
        {
          text: this.translations['Emisores de Tarjetas'],
          sref: 'home.emisores-tarjetas.list',
          classes: ['glyph-icon', 'icon-credit-card'],
          permissions: ['index_tarjetas']
        },
        {
          text: this.translations['Marcas de Tarjetas'],
          sref: 'home.marcas-tarjetas.list',
          classes: ['glyph-icon', 'icon-credit-card'],
          permissions: ['index_tarjetas']
        }, {
          text: this.translations['Tipos de Fondos Fijos'],
          sref: 'home.tipos-movimientos-fondos-fijos.list',
          classes: ['glyph-icon', 'icon-arrows-h'],
          permissions: ['index_tipos_movimientos_fondos_fijos']
        }, {
          text: this.translations['Fondo Fijo'],
          sref: 'home.transacciones-fondos-fijos.list',
          classes: ['glyph-icon', 'icon-archive'],
          permissions: ['index_fondo_fijo']
        }
      ]
    }, {
      header: this.translations['Nómina'],
      nodes: [
        {
          text: this.translations['Periodos de nómina'],
          sref: 'home.periodos-nominas.list',
          classes: ['glyph-icon', 'icon-calendar'],
          permissions: ['index_periodos_nominas']
        }, {
          text: this.translations['Franjas horarias'],
          sref: 'home.franjas-horarias.list',
          classes: ['glyph-icon', 'icon-calendar-o'],
          permissions: ['index_franjas_horarias']
        }, {
          text: this.translations['Turnos de trabajo'],
          sref: 'home.turnos-trabajos.list',
          classes: ['glyph-icon', 'icon-calendar-o'],
          permissions: ['index_turnos_trabajos']
        }, {
          text: this.translations['Tipos de marcación'],
          sref: 'home.tipos-marcaciones.list',
          classes: ['glyph-icon', 'icon-bookmark'],
          permissions: ['index_tipos_marcaciones']
        }, {
          text: this.translations['Tipos de movimiento'],
          sref: 'home.tipos-movimientos-nominas.list',
          classes: ['glyph-icon', 'icon-arrows-h'],
          permissions: ['index_tipos_movimientos_nominas']
        }, {
          text: this.translations['Movimiento Nómina'],
          sref: 'home.movimientos-nominas.list',
          classes: ['glyph-icon', 'icon-arrows-h'],
          permissions: ['index_movimientos_nominas']
        }, {
          text: this.translations['Tipos de movimiento fraccionado'],
          sref: 'home.tipos-movimientos-fraccionados.list',
          classes: ['glyph-icon', 'icon-list-ol'],
          permissions: ['index_tipos_movimientos_fraccionados']
        }, {
          text: this.translations['Movimiento Fraccionado'],
          sref: 'home.movimientos-fraccionados.list',
          classes: ['glyph-icon', 'icon-list-ol'],
          permissions: ['index_movimientos_fraccionados']
        }, {
          text: this.translations['Resumen Asistencias'],
          sref: 'home.asistencias.list',
          classes: ['glyph-icon', 'icon-check-square-o'],
          permissions: ['index_asistencias']
        }, {
          text: this.translations['Resumen Comisiones'],
          sref: 'home.comisiones-empleado.list',
          classes: ['glyph-icon', 'icon-check-square-o'],
          permissions: ['index_resumen_comisiones']
        }, {
          text: this.translations['Liquidación de Salarios'],
          sref: 'home.salarios.list',
          classes: ['glyph-icon', 'icon-money'],
          permissions: ['index_liquidacion_salario']
        }, {
          text: this.translations['Días no laborales'],
          sref: 'home.feriados.list',
          classes: ['glyph-icon', 'icon-calendar-o'],
          permissions: ['index_feriados']
        }, {
          text: this.translations['Empleados'],
          sref: 'home.empleados.list',
          classes: ['glyph-icon', 'icon-group'],
          permissions: ['index_empleados']
        }, {
          text: this.translations['Planillas de salarios'],
          sref: 'home.planillas-salarios.list',
          classes: ['glyph-icon', 'icon-money'],
          permissions: ['index_planillas_salarios']
        }, {
          text: this.translations['Comisiones'],
          sref: 'home.comisiones.list',
          classes: ['glyph-icon', 'icon-money'],
          permissions: ['index_comisiones']
        }, {
          text: this.translations['Disponibilidades'],
          sref: 'home.disponibilidades.list',
          classes: ['glyph-icon', 'icon-calendar'],
          permissions: ['index_disponibilidades']
        }, {
          text: this.translations['Marcaciones'],
          sref: 'home.marcaciones.list',
          classes: ['glyph-icon', 'icon-calculator'],
          permissions: ['index_marcaciones']
        }, {
          text: this.translations['Solicitudes de permiso'],
          sref: 'home.solicitudes-permisos.list',
          classes: ['glyph-icon', 'icon-file-text-o'],
          permissions: ['index_solicitudes_permisos']
        }
      ]
    }, {
      header: this.translations['Administración'],
      nodes: [
        {
          text: this.translations['Usuarios'],
          sref: 'home.usuarios.list',
          classes: ['glyph-icon', 'fa', 'fa-user-o'],
          permissions: ['index_usuarios']
        }, {
          text: this.translations['Roles'],
          sref: 'home.roles.list',
          classes: ['glyph-icon', 'fa', 'fa-check-square-o'],
          permissions: ['index_roles']
        }, {
          text: this.translations['Parámetros'],
          sref: 'home.parametros.list',
          classes: ['glyph-icon', 'fa', 'fa-gears'],
          permissions: ['index_parametros']
        }, {
          text: this.translations['Tipos de impuestos'],
          sref: 'home.tipos-impuestos.list',
          classes: ['glyph-icon', 'fa', 'fa-percent'],
          permissions: ['index_tipos_impuestos']
        }, {
          text: this.translations['Estadisticas'],
          sref: 'home.estadisticas.list',
          classes: ['glyph-icon', 'icon-bar-chart'],
          permissions: ['index_estadisticas']
        }, {
          text: this.translations['Reportes'],
          sref: 'home.reportes.list',
          classes: ['glyph-icon', 'icon-list-alt'],
          permissions: ['index_reportes']
        }
      ]
    }
  ];
}



// WEBPACK FOOTER //
// ./src/components/navigation/navigation.component.js